module.exports = __webpack_public_path__ + "img/VIP-1.ea149a2d.png";